import React from "react";
import { Link } from "react-router-dom";

const ACCENT_COLORS = ["#06B6D4", "#8B5CF6", "#10B981", "#F59E0B", "#F43F5E"];

/**
 * BlogCard renders a single blog preview card. It is used on the Home
 * page (latest posts) and on the Blogs page (full listing), so all of
 * its content comes from props rather than being hard-coded.
 */
const BlogCard = ({ blog, index = 0 }) => {
  const accent = ACCENT_COLORS[index % ACCENT_COLORS.length];

  return (
    <Link
      to={`/blogs/${blog.id}`}
      className="blog-card"
      style={{ display: "block" }}
    >
      <div className="h-2" style={{ height: 8, backgroundColor: accent }} />
      <div style={{ padding: "1.5rem" }}>
        <div
          style={{
            fontSize: "0.875rem",
            color: "var(--text-muted)",
            marginBottom: "0.5rem",
          }}
        >
          {blog.date}
        </div>
        <h3
          style={{
            color: "var(--text-primary)",
            fontWeight: 600,
            fontSize: "1.25rem",
            marginBottom: "0.75rem",
          }}
        >
          {blog.title}
        </h3>
        <p
          style={{
            color: "var(--text-muted)",
            fontSize: "0.875rem",
            lineHeight: 1.6,
            marginBottom: "1rem",
          }}
        >
          {blog.summary}
        </p>
        <span
          style={{
            fontSize: "0.875rem",
            fontWeight: 500,
            color: "var(--accent)",
          }}
        >
          Read More →
        </span>
      </div>
    </Link>
  );
};

export default BlogCard;
